module.exports = __webpack_public_path__ + "static/img/fanyong.10194c50.png";